import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { element } from "protractor";
import { DataService } from "src/app/shared/_http/data.service";

@Component({
  selector: "app-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.scss"],
})
export class HomePageComponent implements OnInit {
  restaurantId: number = 10637;
  restaurantData: any;
  background: any;

  constructor(private dataService: DataService, private sanitizer: DomSanitizer) {
    this.getRestaurantData();
  }

  ngOnInit(): void {
    document.getElementById("defaultOpen").click();
  }

  openPage(elmnt, pageName) {
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablink = document.getElementsByClassName("tablink");
    for (i = 0; i < tablink.length; i++) {
      tablink[i].style.backgroundColor = "#ffffff";
      tablink[i].style.color = "#000000";
    }
    document.getElementById(pageName).style.display = "flex";
    elmnt.target.style.backgroundColor = "#000000";
    elmnt.target.style.color = "#ffffff";
  }

  getRestaurantData() {
    this.dataService.getRestaurantDataByRestaurantId(this.restaurantId).subscribe((res: any) => {
      this.restaurantData = res.website_data;
      this.background = {
        'background-image': `linear-gradient(#0000008a, #0000008a), url('${this.restaurantData.cover_image}')`
      };
    })
  }

  urlSanitizer(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
